import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementPostDetail.graphql';
import { Query, QueryengagementPostDetailArgs } from '../../__generated__/globalTypes';

export const useEngagementPostDetailQuery = (options?: QueryHookOptions<Query, QueryengagementPostDetailArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementPostDetailArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementPostDetailLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementPostDetailArgs>
): QueryResult<Query, QueryengagementPostDetailArgs> & {
  getEngagementPostDetail: LazyQueryExecFunction<Query, QueryengagementPostDetailArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementPostDetail, result] = useLazyQuery<Query, QueryengagementPostDetailArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementPostDetail, ...result };
};

export const useEngagementPostDetailPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementPostDetail = useCallback(
    (options?: Omit<QueryOptions<QueryengagementPostDetailArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementPostDetailArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementPostDetail };
};
// Suspense Query Hooks
export const useEngagementPostDetailSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementPostDetailArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementPostDetailArgs>(QUERY, {
    ...options
  });

  return result;
};
